export const auditPdfPath = auditId => `audit/${auditId}/pdf`;

export const auditFollowUpPdfPath = auditFollowUpId => `audit/follow-up/${auditFollowUpId}/pdf`;
